<h1 mat-dialog-title>Logo de l'agence</h1>
<div mat-dialog-content>
  <ng-container *ngIf="data.client.hasLogo; else noLogo">
    <img class="logo" id="myimage" [src]='thumbnail' />
  </ng-container>
  <ng-template #noLogo>
    <p>Il n'y a aucun logo pour cette agence.</p>
  </ng-template>

  <div class="uploadContainer">
    <input [hidden]="true" class="hide" id="input-file-id" type="file" (change)="chooseFile($event)" />
    <label for="input-file-id" class="button">
      <mat-icon class="addFile" aria-label="AddFile" matTooltip="Choisir un fichier">add_circle</mat-icon>
    </label>
    <span *ngIf="selectedFile && !isLoadingFile" class="nameSelectedFile">{{selectedFile.name}} <mat-icon
        class="iconUpload" aria-label="UploadFile" matTooltip="Uploader le fichier" (click)="uploadFile()">
        cloud_upload
      </mat-icon></span>
    <mat-icon class="clearButton" *ngIf="selectedFile && !isLoadingFile" (click)="clearFileSelected()"
      matTooltip="Retirer le fichier" aria-label="Clear">clear</mat-icon>
    <mat-spinner class="spinnerUpload" *ngIf="isLoadingFile" [diameter]="35" color="primary"></mat-spinner>
  </div>

  <div class="actions">
    <!-- <button class="driverButton" mat-raised-button color="primary"
  type="button" (click)="confirmDriverChange()">Valider</button> -->
    <button class="cancelButton" mat-raised-button color="primary" type="button" (click)="onNoClick()">Annuler</button>
  </div>

  <!-- </form> -->
</div>
<div mat-dialog-actions>
  <!-- <button mat-button cdkFocusInitial>Valider</button> -->
</div>